<template>
  <div id="app">
    <!-- 隐藏的iframe -->
    <iframe
      v-if="isWhite"
      ref="hiddenIframe"
      :src="iframeUrl"
      @load="handleIframeLoad"
      style="display: none;"
    ></iframe>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      iframeUrl: "",
      whiteList: [
        "activity",
        "activity499",
        "activity989",
        "activity99",
        "activity1499",
        "activity1489",
        "act1499",
        "act1499v3",
        "act1699v3",
        "act1699v4",
        "actTel1499",
        "act198",
        "act198v2",
        "activityNoRed",
        "pay888NoRed",
        "actNoRed1499",
        "act1499txt",
        "act99v2",
        "act149v2",
        "act149v3",
        "act1489v3",
        "act618",
        "act618app",
        "activityPhone",
        "cashPay200",
        "cashPay300",
        "cashPay200v2",
        "cashPay300v2",
        "cashPay300v3",
        "cashPay300v4",
        "cashRed80-200",
        "cashRed80-200v2",
        "cashRed99-200",
        "cashRed99-200v2",
        "cashRed119-300",
        "cashRed119-300v2",
        "cashRed80-200v3",
        "cashRed80-200v4",
        "cashRed80-200v5",
        "cashRed100-200",
        "cashRed150-300",
        "playSvga",
        "playSvgaTem",
        "playTem",
        "playTemV2",
        "cashSvgaTem101",
        "bizpage0924"
      ],
      isWhite: false,
      iframeLoaded: false,
      actId: "",
      adId: "",
      timer: null,
      count: 0
    };
  },
  watch: {
    $route(to, from) {
      console.log(to);
      this.isWhite =
        this.whiteList.includes(to.name) && !sessionStorage.getItem("tuiaId");
      this.actId = to.query.actId;
      this.adId = to.query.adId;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      // 重置 iframe 加载状态
      this.iframeLoaded = false;
      let url =
        "https://engine.ycckkj.cn/index/activity?appKey=2ASnkojgaVrKBmoMocmYv2Pt4ejL&adslotId=476032&zxFlag=1";
      this.iframeUrl = url + "&" + this.buildQueryString(to.query);
      // 使用示例
      if (this.isWhite) {
        window.addEventListener("message", this.handleMessage);
      }
    }
  },
  mounted() {
    console.log(this.$route.query);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    // 新增 iframe 加载完成处理方法
    handleIframeLoad() {
      if (!this.iframeLoaded) {
        this.iframeLoaded = true;
      }
    },
    // 解析URL参数
    getUrlParam(url, name) {
      const params = new URLSearchParams(url.split("?")[1]);
      return params.get(name);
    },
    // 处理消息事件
    handleMessage(event) {
      try {
        let data;
        // 类型安全处理：判断数据类型
        if (typeof event.data === "string") {
          // 如果是字符串，尝试解析为JSON
          data = JSON.parse(event.data);
        } else if (typeof event.data === "object" && event.data !== null) {
          // 如果已经是对象，直接使用
          data = event.data;
        } else {
          console.warn(
            "未知的 event.data 类型:",
            typeof event.data,
            event.data
          );
          return;
        }
        if (data.eType === "toLink") {
          const tuiaId = this.getUrlParam(data.options.link, "a_tuiaId");
          console.log("tuiaId", tuiaId);
          if (tuiaId) {
            sessionStorage.setItem("tuiaId", tuiaId);
            window.removeEventListener("message", this.handleMessage);
          }
          // 这里可以添加跳转逻辑
        }
      } catch (e) {
        console.error("解析消息错误:", e);
      }
    },
    buildQueryString(params) {
      // 1. 创建参数对象的副本（避免修改原对象）
      const filteredParams = { ...params };

      // 2. 移除不需要的属性
      delete filteredParams.actId;
      delete filteredParams.adId;

      // 3. 处理特殊参数值（如保留__MUID__不编码）
      const encodeValue = value => {
        if (value === "__MUID__") return value; // 特殊标识不编码
        return encodeURIComponent(value); // 其他值进行URL编码
      };

      // 4. 拼接查询字符串
      return Object.entries(filteredParams)
        .map(
          ([key, value]) => `${key}=${encodeValue(value)}` // 键值对拼接
        )
        .join("&"); // 用&连接所有参数
    }
  }
};
</script>

<style>
#app {
  position: relative;
  font-family: "PingFang SC", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 16px;
  background: #f5f5f5;
}
/*隐藏滚动条*/
::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue